import React from 'react';
// import './PricingSection.css';
import { NavLink } from 'react-router-dom';

const PricingSection = () => (
  <section className="pricing-section-custom">
    <div className="container">
    <div className="pricing-label">Pricing Plans</div>
    <h2 className="pricing-title">
      CHOOSE THE RIGHT PLAN FOR YOUR <span className="pricing-gradient">BUSINESS</span>
    </h2>
    <p className="pricing-desc">
      Whether you're a small team or large enterprise, we have flexible pricing options to fit your needs
    </p>
    <div className="pricing-btn-row">
      <NavLink to="/pricing" className="pricing-btn-primary">View Pricing Option <span className="arrow-icon">→</span></NavLink>
      {/* <NavLink to="/contact-us" className="pricing-btn-secondary">Contact</NavLink> */}
    </div>
    </div>
  </section>
);

export default PricingSection; 